var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['page-container']},[_c('wt-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }